export default "__VITE_ASSET__BXmiOsC9__"